<clr-input-container>
  <input
    clrInput
    name="value"
    [ngModel]="exact"
    (ngModelChange)="accepts($event)"
    type="number"
  />
</clr-input-container>
